module.exports = __webpack_public_path__ + "static/media/gray-circle.4524a1b3.png";